import NewsSlider from "@src/pages/News/NewsSlider";
import React from "react";
import { getValueOrDefault } from "@src/utils/ConditionHelper";
import type { INewsItem } from "@src/types/AppTypes";

const NewsCategory: React.FC<{
  inLightNews: INewsItem[];
  inHouseList: INewsItem[];
  newsList: INewsItem[];
  returnBgImages: (index: number) => string;
  readMoreTitle?: string;
}> = ({
  inLightNews,
  inHouseList,
  newsList,
  returnBgImages,
  readMoreTitle,
}) => {
  return (
    <>
      <section>
        {inLightNews.length > 0 && (
          <div className="py-10 max-md:py-6 px-4 news-slider half-pink-radial-bg">
            <div className="first-half"></div>
            <div className="container mx-auto max-md:px-0">
              <h2 className="text-lightBlue text-6xl max-md:text-4xl max-sm:text-3xl max-md:mb-10 max-sm:mb-5 text-start mb-7">
                {getValueOrDefault(readMoreTitle, "Fatsu in Lights")}
              </h2>
            </div>
            <NewsSlider
              showNews={true}
              newsList={inLightNews}
              inHouseList={inHouseList}
              returnBgImages={returnBgImages}
            />
          </div>
        )}
      </section>
      <section>
        {newsList.length > 0 && (
          <div className="py-10 max-md:py-6 px-4 news-slider half-pink-radial-bg">
            <div className="first-half"></div>
            <div className="container mx-auto max-md:px-0">
              <h2 className="text-lightBlue text-6xl max-md:text-4xl max-sm:text-3xl text-start mb-10 max-md:mb-6 break-all">
                {getValueOrDefault(readMoreTitle, "In the News")}
              </h2>
            </div>
            <NewsSlider
              showNews={true}
              newsList={newsList}
              inHouseList={inHouseList}
              returnBgImages={returnBgImages}
            />
          </div>
        )}
      </section>
      <section>
        {inHouseList.length > 0 && (
          <div className="py-12 news-slider half-pink-radial-bg">
            <div className="first-half"></div>
            <div className="container mx-auto max-md:px-0">
              <h2 className="text-lightBlue text-8xl max-md:text-6xl max-md:mb-10 mb-10 text-center">
                {getValueOrDefault(readMoreTitle, "In-House News")}
              </h2>
            </div>
            <NewsSlider
              showNews={false}
              newsList={newsList}
              inHouseList={inHouseList}
              returnBgImages={returnBgImages}
            />
          </div>
        )}
      </section>
    </>
  );
};

export default NewsCategory;
